import axios from '../../config/axios.js'
import { addIso690 } from '../../custom/function'

const STATE = {

    projects: null,
    project_info: {},
    proj_note_info: {},
    documents: [],

}

const GETTERS = {

    projects: state => state.projects,
    project_info: state => state.project_info,
    proj_note_info: state => state.proj_note_info,
    documents: state => state.documents,

}

const MUTATIONS = {

    getProjects(state, projects) {
        state.projects = projects
    },

    getProject(state, project_info) {
        state.project_info = project_info
    },

    getProjNoteInfo(state, note) {
        state.proj_note_info = note
    },

    getDocumentsInProject(state, documents) {
        state.documents = documents
    },

}

const ACTIONS = {

    async getProjects({ commit }) {
        await axios.ACCESS.get('/api/s2/guestprojects')
            .then(res => {
                // console.log('watching/getProjects', res)
                if (res.data.result) {
                    commit('getProjects', res.data.guestprojects)
                } else { throw new Error(res.data) }
            })
    },

    async responseInvitation({ dispatch }, payload) {
        await axios.ACCESS.patch('/api/s2/guestproject/' + payload.proj_id, {
                response: 1,
                status: payload.status,
            })
            .then(res => {
                // console.log('watching/responseInvitation', res)
                if (res.data.result) {
                    dispatch('getProjects')
                } else { throw new Error(res.data) }
            })
    },

    async getProject({ commit, dispatch }, proj_id) {
        await axios.ACCESS.get('/api/s2/guestproject/' + proj_id + '/info')
            .then(res => {
                // console.log('watching/getProject', res)
                if (res.data.result) {
                    commit('getProject', res.data.guestproject)
                    dispatch('getDocumentsInProject', proj_id)
                } else { throw new Error(res.data) }
            })
    },

    async getDocumentsInProject({ commit }, proj_id) {
        await axios.ACCESS.get('/api/s2/guestproject/' + proj_id + '/documents')
            .then(res => {
                // console.log('watching/getDocuments', res)
                if (res.data.result) {
                    addIso690(res.data.documents)
                        .then(res => {
                            res.forEach(doc => Object.keys(doc).forEach(k => doc[k] = doc[k] == 'null' ? 'n.r.' : doc[k]))
                            commit('getDocumentsInProject', res)
                        })
                } else { throw new Error(res.data) }
            })
    },

    async getProjNoteInfo({ commit }, proj_id) {
        await axios.ACCESS.get('/api/s2/guestproject/' + proj_id + '/note')
            .then(res => {
                // console.log('watching/getProjNoteInfo', res)
                if (res.data.result) {
                    commit('getProjNoteInfo', res.data.note)
                } else { throw new Error(res.data) }
            })
    },

}

export default {
    namespaced: true,
    state: STATE,
    getters: GETTERS,
    mutations: MUTATIONS,
    actions: ACTIONS,
}


// WEBPACK FOOTER //
// ./src/vuex/modules/watching.js